<template>
  <div style="width:45px;" v-if="loading">
    <lottie-player
        class="lottieAnimation"
        src="/lottie/map-load.json"
        background="transparent"
        speed="1"
        style="width:100%"
        loop
        autoplay
    />
  </div>
</template>
<script lang="ts">

import { defineComponent, PropType } from "vue";
import MapButton from "../MapButton.vue";
import { MapController } from "../../../js/Map/map-controller";
import { BehaviorSubject, debounceTime } from "rxjs";
import { MapEvent } from "../../../js/document/model/map";

export default defineComponent({
  name: 'MapStateControl',
  components: { MapButton },
  props: {
    mapController: {
      type: Object as PropType<MapController>,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      ticker: new BehaviorSubject<number>(0)
    }
  },
  created() {
    this.ticker.pipe(debounceTime(500)).subscribe(() => this.endLoading());

    this.mapController.mapInstance.on(MapEvent.LayerAdding, e => this.startLoading())
    this.mapController.mapInstance.on(MapEvent.LayerRemoving, e => this.startLoading())

    this.mapController.mapInstance.on('dataloading', e => {
      if (e.sourceId?.startsWith('mapbox-gl-draw')) {
        return;
      }
      this.startLoading();
    });
    this.mapController.mapInstance.on('data', e => this.endLoading());
    this.mapController.mapInstance.on(MapEvent.LayerRemove, e => {

    });
  },
  methods: {
    startLoading() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$forceUpdate();
    },
    endLoading() {
      if (!this.loading) {
        return;
      }

      if (!this.mapController.isLoaded()) {
        this.ticker.next(this.ticker.value + 1);
        return;
      }
      this.loading = false;
      this.$forceUpdate();
    }
  }
})
</script>
